import { render } from "./CfrTestReport.vue?vue&type=template&id=861cb976&scoped=true&ts=true"
import script from "./CfrTestReport.vue?vue&type=script&lang=ts"
export * from "./CfrTestReport.vue?vue&type=script&lang=ts"

import "./CfrTestReport.vue?vue&type=style&index=0&id=861cb976&scoped=true&lang=css"
import "./CfrTestReport.vue?vue&type=style&index=1&id=861cb976&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861cb976"]])

export default __exports__